import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {DirtyWildsParsedInitData} from "../../server/data/DirtyWildsParsedInitData";
import {DirtyWildGameMode} from "../DirtyWildsRespinZeroBetController";
import {DirtyWildsGameConfig} from "../../DirtyWildsGameConfig";
import {DirtyWildsStateReelSymbol, DirtyWildsSymbols} from "../../symbols/DirtyWildsStateReelSymbol";
import {DirtyWildsParsedGameData, WildSymbolData} from "../../server/data/DirtyWildsParsedGameData";
import {TimelineLite, TweenMax} from "gsap";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Matrix} from "../../../utils/Matrix";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {DirtyWildGameModuleConfig} from "../../DirtyWildGameModuleConfig";


/**
 * Created by Jonas Wålekvist on 2018-09-26.
 */

export class DirtyWildsOverlayController {

    private _initSpinsRemaining:number;
    private _initMultiplier:number;
    private _nextMode:string;
    private _allOverlaySymbols:Matrix<StateReelSymbol | null>;
    private _afterStopSpinsRemaining:number;
    private _positionsWildInfo:WildSymbolData[] = [];
    private _initMultiplierIndex:number;
    private _mode:string;
    private _afterStopMultiplier:number;
    private _afterStopMultiplierIndex:number;
    private _isRestore:boolean;


    constructor() {
        this._allOverlaySymbols = new Matrix<StateReelSymbol | null>(5, 3, null);
        this.addEventHandlers();
    }

    protected addEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());

        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeStart());
        EventHandler.addEventListener(this, WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED, (event:GameEvent) => this.onAllWinsComplete());
    }

    public isRestoreState():boolean{
        return this._isRestore;
    }

    //DATA HANDLING
    private setBaseData(data:DirtyWildsParsedInitData | DirtyWildsParsedGameData) {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._positionsWildInfo = data.positionsWildInfo;
    }

    protected onInitDataParsed(data:DirtyWildsParsedInitData):void {
        this.setBaseData(data);
        this._isRestore = data.isRestoreState;
        this._initSpinsRemaining = data.initSpinsRemaining;
        this._initMultiplier = data.initMultiplier;
        this._initMultiplierIndex = data.initIndex;

        this._afterStopSpinsRemaining = this._initSpinsRemaining;

    }

    protected onGameDataParsed(data:DirtyWildsParsedGameData):void {
        this.setBaseData(data);
        this._afterStopSpinsRemaining = data.afterStopSpinsRemaining;
        this._afterStopMultiplier = data.afterStopMultiplier;
        this._afterStopMultiplierIndex = data.afterStopMultiplierIndex;
    }


    //EVENT HANDLERS
    private onRestore() {
        this._isRestore = true;
        DirtyWildGameModuleConfig.effectManager.getChangeBackgroundAnimation(DirtyWildGameMode.STICKY_RESPIN, 0.1);
        DirtyWildGameModuleConfig.topBarView.setTopBar(this._initMultiplierIndex, this._initMultiplier, this._initSpinsRemaining, true);
    }

    private onAllWinsComplete() {
        if(this._mode == DirtyWildGameMode.STICKY_RESPIN && this._nextMode == DirtyWildGameMode.NORMAL) {
            // this.getEndAnimation();
        }
    }


    //START / END RESPIN FEATURE.
    private getEndAnimation():TimelineLite {
        const tl = new TimelineLite({onComplete: () => {
                DirtyWildGameModuleConfig.soundPlayer.switchToMainMusic();
                DirtyWildGameModuleConfig.effectManager.getChangeBackgroundAnimation(DirtyWildGameMode.NORMAL, 2)
            }});
        tl.add([
            DirtyWildGameModuleConfig.topBarView.setTopBar(0, 1, 0)
        ]);
        return tl;
    }


    private onBeforeStart() {
        //This happens before  we get new data from server. The effect is that we use data from perv spin.
        if(this._nextMode == DirtyWildGameMode.STICKY_RESPIN) {
            this.fetchOverlaySymbolsFromReel();
        }

        if(this._nextMode == DirtyWildGameMode.STICKY_RESPIN && this._isRestore){
            DirtyWildGameModuleConfig.soundPlayer.switchToFreespinMusic();
        }
        this._isRestore = false;
    }


    private fetchOverlaySymbolsFromReel() {
        this._allOverlaySymbols.populate(null);
        for(let overlay of this._positionsWildInfo) {
            const symbol:StateReelSymbol | null = Reels.getSymbol(overlay.wildPosition[0], overlay.wildPosition[1]);
            if(symbol) {
                this._allOverlaySymbols.addItemAtPosition(symbol, overlay.wildPosition);
                (<DirtyWildsStateReelSymbol>symbol).liftOutOfReels();
                symbol!.changeState({
                    state : DirtyWildsGameConfig.instance.SYMBOL_STATES.stickyInitial,
                    fadeInDuration : 0
                });
            }
        }
    }

    public getFadeOutOverlays():TimelineLite {
        const tl = new TimelineLite();
        const centerSymbol = this._allOverlaySymbols.getItemAt(2, 1);
        const shouldFadeCenter:boolean = (this._afterStopSpinsRemaining == 1);
        let hasCoolDownSym:boolean = false;
        for(let symbol of this._allOverlaySymbols.getAllItems()) {
            if(symbol == centerSymbol) {
                continue;
            }
            tl.add(symbol!.changeState({
                state : DirtyWildsGameConfig.instance.SYMBOL_STATES.coolDown,
                fadeInDuration : 0
            }), 0);
            hasCoolDownSym = true;
        }
        return tl;
    }

    public addOverlayBackInReel(pos:[number, number], isDoubleWild:boolean = false) {
        if(this._allOverlaySymbols.getItemAtPosition(pos)) {
            const reelSymbol = Reels.getSymbol(pos[0], pos[1]);
            const overlay = this._allOverlaySymbols.getItemAtPosition(pos);
            this._allOverlaySymbols.addItemAtPosition(null, pos);
            (<DirtyWildsStateReelSymbol>reelSymbol).replaceWithSymbol(overlay!);
        }
    }

    public animateSymbolsBeforeTransform(wildSymbolData:WildSymbolData[]):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        for(let data of wildSymbolData) {
            const oldSymbol:DirtyWildsStateReelSymbol = <DirtyWildsStateReelSymbol>Reels.getSymbol(data.wildPosition[0], data.wildPosition[1]);
            if(oldSymbol.symName != DirtyWildsSymbols.W) {
                tl.add(TweenMax.to(oldSymbol, 0.04, {x: "+=2", y: "+=2", yoyo: true, repeat: 5}));
                tl.add(TweenMax.to(oldSymbol, 0.04, {x: "-=2", y: "-=2" ,yoyo: true, repeat: 5}));
            }
        }
        return tl;
    }


    public getOverlaySymbolAt(position:[number, number]):StateReelSymbol | null {
        return this._allOverlaySymbols.getItemAtPosition(position);
    }


}